import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AutoCompleteModule, ButtonModule, CalendarModule, CheckboxModule, DropdownModule, InputMaskModule, InputTextareaModule, InputTextModule, MessageModule, MessagesModule, SelectButtonModule } from 'primeng/primeng';
import { ButtonsButtonComponent } from './buttons-button/buttons-button.component';
import { ButtonsLinkComponent } from './buttons-link/buttons-link.component';
import { ButtonsLinkBarComponent } from './buttons-linkbar/buttons-linkbar.component';
import { FormsAutoCompleteComponent } from './forms-autocomplete/forms-autocomplete.component';
import { FormsCheckboxComponent } from './forms-checkbox/forms-checkbox.component';
import { FormsLabelComponent } from './forms-label/forms-label.component';
import { FormsTextareaComponent } from './forms-textarea/forms-textarea.component';
import { FormsTextfieldComponent } from './forms-textfield/forms-textfield.component';
import { MessagesBannerComponent } from './messages-banner/messages-banner.component';
import { NavigationBreadcrumbComponent } from './navigations-breadcrumb/navigations-breadcrumb.component';
import { NavigationIconFilterComponent } from './navigations-iconfilter/navigations-iconfilter.component';
import { NavigationTabComponent } from './navigations-tab/navigations-tab.component';
import { UIDatePickerComponent } from './ui-datepicker/ui-datepicker.component';
import { UIProgressComponent } from './ui-progress/ui-progress.component';








@NgModule({
  imports: [
    CommonModule,
    AutoCompleteModule,
    ButtonModule,
    CheckboxModule,
    DropdownModule,
    InputTextModule,
    InputMaskModule,
    MessagesModule,
    MessageModule,
    SelectButtonModule,
    InputTextareaModule,
    TranslateModule.forChild()
  ],
  providers: [
  ],
  declarations: [
    ButtonsButtonComponent,
    ButtonsLinkComponent,
    ButtonsLinkBarComponent,

    FormsLabelComponent,
    FormsTextfieldComponent,
    FormsCheckboxComponent,
    FormsTextareaComponent,
    FormsAutoCompleteComponent,

    MessagesBannerComponent,

    NavigationTabComponent,
    NavigationIconFilterComponent,
    NavigationBreadcrumbComponent,

    UIDatePickerComponent,
    UIProgressComponent
  ],
  exports: [
    CommonModule,

    AutoCompleteModule,
    ButtonModule,
    CheckboxModule,
    InputTextModule,
    InputMaskModule,
    MessagesModule,
    MessageModule,
    SelectButtonModule,
    CalendarModule,
    InputTextareaModule,

    ButtonsButtonComponent,
    ButtonsLinkComponent,
    ButtonsLinkBarComponent,

    FormsLabelComponent,
    FormsTextfieldComponent,
    FormsCheckboxComponent,
    FormsTextareaComponent,
    FormsAutoCompleteComponent,

    MessagesBannerComponent,

    NavigationTabComponent,
    NavigationIconFilterComponent,
    NavigationBreadcrumbComponent,

    UIDatePickerComponent,
    UIProgressComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ComponentsModule {}
